const config = {
    movie_asp: 1280 / 720,
}
const $window = $(window);

module.exports = function(hash){
    const width = $window.width();
    const height = $window.height();
    const window_asp = width / height;
    const movie_width = height*config.movie_asp;
    const movie_height = width/config.movie_asp;
    const adjust = -(movie_width - width)/2;
    if(window_asp >= config.movie_asp){
        $('#bgMovie--' + hash).css({
            position: 'absolute',
            width: '100%',
            height: movie_height,
        });
    }else{
        $('#bgMovie--' + hash).css({
            position: 'absolute',
            width: movie_width,
            height: '100%',
            left: adjust
        });
    }
}



// WEBPACK FOOTER //
// ./es2015/module/_ajust_movie_size.js